export default __webpack_public_path__ + "static/media/seedcamp-logo.c7576103.png";